import {EnumQuoteServiceType} from "../enum/enum-quote-service-type";
import {WEEK_AVERAGE} from "../../utils/constants";

export class BillingLine {
    contractId: string;
    keyAccountCode: string;
    deliveryPointCode: string;
    deliveryPointName: string;
    productLine: string;
    serviceCenter: number;
    articleCode: string;
    billingCategoryCode: string;
    articleType: string;
    articleFamily: string;
    articleName: string;
    serviceFrequency: string;
    chargingType: string;
    weeklyQuantity: number;
    monthlyQuantity: number;
    unitPrice: number;
    weeklyAmount: number;
    monthlyAmount: number;
    consumptionAllowance: string;
    relatedDeviceItemCode: string;
    unitPriceExtra: number;
    numberOfChanges: string;
    garmentStock: string;
    nbWearers: number;
    serviceType: string;
    exchangeRule: string;
    finishingMethod: string;
    invoiceDate: string;
    servicePricing: EnumQuoteServiceType;
    consoType?: string;

    get isConsumable(): boolean {
        let consoTypes = ['RELOAD', 'SPOOL'];
        return consoTypes.includes(this.articleType);
    }

    getBilledQuantity(): number {
        if (this.servicePricing === EnumQuoteServiceType.VT || this.servicePricing === EnumQuoteServiceType.LS) {
            return this.weeklyQuantity;
        }
        return this.monthlyQuantity;
    }

    getBilledRevenue(): number {
        if (this.servicePricing === EnumQuoteServiceType.VT || this.servicePricing === EnumQuoteServiceType.LS) {
            return this.weeklyAmount;
        }
        return this.monthlyAmount;
    }

    getMonthlyBilledRevenue(): number {
        if (this.servicePricing === EnumQuoteServiceType.VT || this.servicePricing === EnumQuoteServiceType.LS) {
            return this.weeklyAmount * parseFloat(WEEK_AVERAGE);
        }
        return this.monthlyAmount;
    }
    static fromJson(json: any): BillingLine {
        return Object.assign(new BillingLine(), json);
    }

    static fromJsonArray(jsonArray: any[]): BillingLine[] {
        return jsonArray.map(json => BillingLine.fromJson(json));
    }

    getFranchiseConso(): string{
        const franchiseConso = Math.max(0,Number(this.consumptionAllowance) - Number(this.monthlyQuantity));
        return this.isConsumable && franchiseConso.toString();
    }
}
